import React, { useEffect, useState } from 'react';
import { Modal, Card, CardBody, Form, Button, FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import classnames from 'classnames';
import { connect } from 'react-redux';
import reduxHelper from '../../../../helper/index.js';

function CompanyCreateModal(props){
  const { isOpen, openModal, toggle, companyId, onSaved, notify, translate = {} } = props;
  const helper = new reduxHelper(props);
  const [dialog, setDialog] = useState({ name: '', groupname: '', license: '', login_google: '0', user_limit: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setError('');
      if (!companyId) {
        setDialog({ name: '', groupname: '', license: '', login_google: '0', user_limit: '' });
        return;
      }
      setLoading(true);
      try {
        const resp = await helper.company().getCompany(companyId);
        let payload = {};
        if (resp && resp.data) payload = (resp.data.data && resp.data.data[0]) ? resp.data.data[0] : resp.data;
        // fallback shapes
        payload = payload || {};
        const d = {
          name: payload.name || payload.company_name || '',
          groupname: payload.groupname || payload.group || '',
          license: payload.license || payload.license_key || '',
          login_google: (payload.login_google !== undefined && payload.login_google !== null) ? String(payload.login_google) : '0',
          user_limit: (payload.user_limit === null || payload.user_limit === undefined) ? '' : payload.user_limit
        };
        if (mounted) setDialog(d);
      } catch (e) {
        if (mounted) setError(translate['erro_ao_carregar_unidade'] || 'Erro ao carregar unidade');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (openModal || isOpen) load();
    return () => { mounted = false; };
  }, [isOpen, companyId]);

  const handleChange = name => event => { setDialog(d => ({ ...d, [name]: event.target.value })); };

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setSaving(true);
    setError('');
    const data = { ...dialog };
    if (data.user_limit === '') delete data.user_limit;
    try {
      let resp;
      if (companyId) {
        resp = await helper.company().putCompany(companyId, data);
      } else {
        resp = await helper.company().postCompany(data);
      }
      if (resp && resp.status === 200) {
        try {
          if (notify) notify({place: "tr", message: (<div className="alert-text"><span className="alert-title" data-notify="title">{translate['sucesso'] || 'Sucesso'}.</span><span data-notify="message">{companyId ? (translate['as_alteracoes_foram_salvas'] || 'As alterações foram salvas') : (translate['a_unidade_foi_cadastrada'] || 'A unidade foi cadastrada')}</span></div>), type: 'success', icon: "ni ni-check-bold", autoDismiss: 7});
        } catch(e) {}
        if (onSaved) await onSaved();
        toggle && toggle();
      } else if (resp && resp.status === 400) {
        const msg = resp.data && resp.data.data && resp.data.data.msg ? resp.data.data.msg : (resp.data && resp.data.msg) || (translate['erro'] || 'Erro');
        setError(msg);
      } else {
        setError(translate['erro_desconhecido'] || 'Erro desconhecido');
      }
    } catch (err) {
      console.error('Company save error', err);
      setError((err && err.message) ? err.message : (translate['erro_ao_salvar'] || 'Erro ao salvar unidade'));
    } finally {
      setSaving(false);
    }
  };

  const title = companyId ? (translate['editar_unidade'] || 'Editar unidade') : (translate['criar_unidade'] || 'Criar unidade');
  const saveLabel = companyId ? (translate['salvar_alteracoes'] || 'Salvar alterações') : (translate['cadastrar'] || 'Cadastrar');

  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen}>
      <div className="modal-body p-0">
        <Card className="bg-secondary border-0 mb-0">
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-default">{title}</h6>
            <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={toggle}><span aria-hidden={true}>×</span> </button>
          </div>
          <CardBody className="px-lg-5">
            <Form autoComplete="off" role="form" type="post" onSubmit={handleSave}>
              {error && error !== "" && <div className="alert alert-danger">{error}</div>}
              <FormGroup>
                <h5>{translate['nome'] || 'Nome'}</h5>
                <InputGroup className={classnames("input-group-merge input-group-alternative")}>
                  <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-caps-small" /></InputGroupText></InputGroupAddon>
                  <Input type="text" onChange={handleChange('name')} value={dialog.name || ''} />
                </InputGroup>
              </FormGroup>

              <FormGroup>
                <h5>{translate['grupo'] || 'Grupo'}</h5>
                <InputGroup className={classnames("input-group-merge input-group-alternative")}>
                  <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-caps-small" /></InputGroupText></InputGroupAddon>
                  <Input type="text" onChange={handleChange('groupname')} value={dialog.groupname || ''} />
                </InputGroup>
              </FormGroup>

              <FormGroup>
                <h5>{translate['licenca'] || 'Licença'}</h5>
                <InputGroup className={classnames("input-group-merge input-group-alternative")}>
                  <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-archive-2" /></InputGroupText></InputGroupAddon>
                  <Input type="text" onChange={handleChange('license')} value={dialog.license || ''} />
                </InputGroup>
              </FormGroup>

              <FormGroup>
                <h5>{translate['limite_de_usuarios'] || 'Limite de usuários'}</h5>
                <InputGroup className={classnames("input-group-merge input-group-alternative")}>
                  <InputGroupAddon addonType="prepend"><InputGroupText><i className="fas fa-users" /></InputGroupText></InputGroupAddon>
                  <Input type="number" min="0" onChange={handleChange('user_limit')} value={dialog.user_limit === null || dialog.user_limit === undefined ? '' : dialog.user_limit} placeholder="Deixe em branco para sem limite" />
                </InputGroup>
                <small className="text-muted">{translate['deixe_em_branco_para_sem_limite'] || 'Deixe em branco para sem limite'}</small>
              </FormGroup>

              <FormGroup>
                <h5>{translate['login_apenas_google'] || 'Login apenas com Google'}</h5>
                <InputGroup className={classnames("input-group-merge input-group-alternative")}>
                  <InputGroupAddon addonType="prepend"><InputGroupText><i className="fab fa-google" /></InputGroupText></InputGroupAddon>
                  <Input type="select" onChange={handleChange('login_google')} value={dialog.login_google || '0'}>
                    <option value="0">{translate['nao'] || 'Não'}</option>
                    <option value="1">{translate['sim'] || 'Sim'}</option>
                  </Input>
                </InputGroup>
              </FormGroup>

              <div className="d-flex justify-content-between align-items-center">
                <div></div>
                <div className="text-right">
                  <Button className="my-4" color="default" type="button" onClick={toggle}>{translate['cancelar'] || 'Cancelar'}</Button>
                  <Button className="my-4 ml-2" color="primary" type="submit" disabled={saving}>{saving ? (translate['salvando'] || 'Salvando...') : saveLabel}</Button>
                </div>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </Modal>
  );
}

export default connect(state => ({ translate: state.translate }))(CompanyCreateModal);
